/** Revalida módulos estáticos antes da recarga solicitada pela pessoa.
 * WebKit pode conservar uma falha de modulepreload entre recargas. Só ativos
 * públicos do mesmo aplicativo são consultados, sem cookies e com prazo limitado.
 */
export async function refreshPreloadedAssets(): Promise<void> {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 5000);
  try {
    const paths = Array.from(
      document.querySelectorAll<HTMLLinkElement>('link[rel="modulepreload"]'),
    )
      .map((link) => new URL(link.href, window.location.href))
      .filter((url) => url.origin === window.location.origin && url.pathname.startsWith('/assets/'))
      .map((url) => url.href);
    await Promise.allSettled(
      [...new Set(paths)].map((url) =>
        fetch(url, {
          cache: 'reload',
          credentials: 'omit',
          signal: controller.signal,
        }).then((response) => response.arrayBuffer()),
      ),
    );
  } finally {
    clearTimeout(timeout);
  }
}
